module.exports = __webpack_public_path__ + "static/media/playstore_color.bd0a4db0.svg";